module.exports = __webpack_public_path__ + "static/media/Loading.d7c13cbf.gif";